import { cx } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import { NothingToShowProps } from "./NothingToShow.types";
import { NothingToShowRoot } from "./NothingToShow.styles";
import { useTheme } from "styled-components";
import { Col, Typography } from "@commonlibs";
import { WindIcon } from "ui/common/icons";

const NothingToShow = ({ className, style, label }: NothingToShowProps): JSX.Element => {
    const translate = useTranslate();
    const { spacing } = useTheme();
    return (
        <NothingToShowRoot className={cx("nothing-to-show", className)} style={style}>
            <Col alignItems="center" gap={spacing[2]}>
                <WindIcon css={{ fontSize: "3rem" }} />
                <Typography variant="body3Strong" textAlign="center">
                    {label || translate("nothingToShow")}
                </Typography>
            </Col>
        </NothingToShowRoot>
    );
};

export default NothingToShow;
